/**
 * Composable для управления z-index вложенных модальных окон
 * Обеспечивает, чтобы каждый новый диалог имел больший z-index, чем предыдущие
 */
let dialogCounter = 0
const dialogStack: number[] = []

export function useDialogZIndex() {
  const registerDialog = () => {
    dialogCounter++
    const zIndex = 50 + dialogCounter * 10 // Базовый z-50, каждый новый диалог +10
    dialogStack.push(zIndex)
    return zIndex
  }

  const unregisterDialog = () => {
    dialogStack.pop()
    dialogCounter = Math.max(0, dialogCounter - 1)
  }

  const getCurrentZIndex = () => {
    return dialogStack.length > 0 ? dialogStack[dialogStack.length - 1] : 50
  }

  return {
    registerDialog,
    unregisterDialog,
    getCurrentZIndex,
  }
}




